import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Box, CircularProgress } from '@mui/material';
import { supabase } from './supabase/client';
import Main from './frontend';
import Login from './frontend/Login';
import { theme } from './frontend/theme';
import './index.css';
const ALLOWED_EMAIL = 'grunfeldlea@gmail.com';
function Root() {
    const [session, setSession] = useState(undefined);
    const [unauthorizedEmail, setUnauthorizedEmail] = useState();
    useEffect(() => {
        const handleSession = (next) => {
            if (next && next.user.email !== ALLOWED_EMAIL) {
                setUnauthorizedEmail(next.user.email);
                supabase.auth.signOut();
                setSession(null);
                return;
            }
            setUnauthorizedEmail(undefined);
            setSession(next);
        };
        supabase.auth
            .getSession()
            .then(({ data: { session: initial } }) => {
            handleSession(initial);
        });
        const { data: { subscription }, } = supabase.auth.onAuthStateChange((_event, next) => handleSession(next));
        return () => subscription.unsubscribe();
    }, []);
    if (session === undefined) {
        return (_jsx(Box, { sx: {
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }, children: _jsx(CircularProgress, {}, void 0) }, void 0));
    }
    return session ? _jsx(Main, {}, void 0) : _jsx(Login, { unauthorizedEmail: unauthorizedEmail }, void 0);
}
const container = document.getElementById('root');
if (!container)
    throw new Error('Root container not found');
const root = createRoot(container);
root.render(_jsxs(ThemeProvider, { theme: theme, children: [_jsx(CssBaseline, {}, void 0), _jsx(BrowserRouter, { children: _jsx(Root, {}, void 0) }, void 0)] }, void 0));
